import React from 'react';
import { Box, PresentationalCheckboxGroup } from '@opendoor/bricks/core';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { ClosedOffer, UnderContractOffer } from 'sellDirect/OfferContext';

interface IProps {
  offer: UnderContractOffer | ClosedOffer;
  resetableForm: IResetableFormRenderProps;
}

/**
 * Users need to declare that they have left their home empty and in the agreed upon condition
 * This component renders a checkbox that they can click to verify their agreement with the condition
 *
 * storybook-check-ignore
 */
export const DigitalCheckoutDeclaration: React.FC<IProps> = ({ offer, resetableForm }) => {
  const photolessOverride = offer.closingExperience?.digitalCheckout?.photolessOverride;
  const { onUpdate, formState } = resetableForm;
  const address = offer.address.street || 'at this address';

  const label = offer.shouldSeeAgentExperience
    ? `I verify that my client has vacated the home at ${address}. I also verify that my client has left the home in good condition, and that the home is free of all occupants (including tenants), debris, and belongings. Opendoor may enter the home to do a walk-through.`
    : `I verify that I have vacated my home at ${address}. I also verify that I have left the home in good condition, and that the home is free of all occupants (including tenants), debris, and belongings. Opendoor may enter the home to do a walk-through.`;
  const value = photolessOverride ? 'override' : 'standard';

  return (
    <Box data-testid="dco-declaration-info" width="100%">
      <PresentationalCheckboxGroup
        analyticsName="cake-digital-checkout-declaration"
        data-testid="dco-checkbox"
        name="digital-checkout-declaration"
        options={[{ label, value }]}
        selectedValues={formState?.declaration ? [value] : []}
        onClick={() => {
          onUpdate('declaration', formState?.declaration ? undefined : value);
        }}
      />
    </Box>
  );
};
